export default __webpack_public_path__ + "static/media/font-size.5160d8c2.svg";